import { render, staticRenderFns } from "./NewsletterList.vue?vue&type=template&id=763e6ad3&scoped=true&"
import script from "./NewsletterList.vue?vue&type=script&lang=js&"
export * from "./NewsletterList.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterList.vue?vue&type=style&index=0&id=763e6ad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763e6ad3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
